<template>
  <destroy-button
    v-if="!params.data.proc_button_destroy"
    :disabled_button="false"
    @destroyEvent="params.destroyEvent(params.data)"
    :label="params.destroy_label"
    :title="params.destroy_title"
    :message="params.destroy_message"
    :label_confirm="params.destroy_label_confirm"
  />
  <destroy-button-processing v-else :label="params.destroy_label" />
</template>

<script>
export default {
  name: "AgGridDestroyButton",
};
</script>
